// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__3wvlM","Open":"SideDrawer__Open__3xsf8","Close":"SideDrawer__Close__2S6c7","Header":"SideDrawer__Header__2ARUB","Logo":"SideDrawer__Logo__10IHv","BrandName":"SideDrawer__BrandName__3XC9b","CloseButton":"SideDrawer__CloseButton__TOz8X","Footer":"SideDrawer__Footer__8wHeg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideDrawer/SideDrawer.css
// module id = 35
// module chunks = 0